export abstract class Path {
    public static readonly HOME = '/';

    public static readonly ABOUT = '/about';

    public static readonly PORTFOLIO = '/portfolio';
    public static readonly FRAT = '/portfolio/frat';
    public static readonly STAGE_ART = '/portfolio/stage-art';
    public static readonly BINANCE_BOT = '/portfolio/binance-bot';
    public static readonly ZLOTE_MYSLI = '/portfolio/zlote-mysli';

    public static readonly PRIVACY_POLICY = '/privacy-policy';
}